import { gql } from '@apollo/client'

export const EXPORT_RESOURCES_SOURCES_READONY_QUERY = gql`
  query ResourcesSources(
    $first: Int
    $after: String
    $where: ResourcesSourcesGraphQlFilterInput
    $order: [ResourcesSourcesGraphQlSortInput!]
  ) {
    resourcesSources(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        resourceId
        state
        resourceName
        sourceName
        combinedName
        lastPublishedDate
        researcherName
        defaultSource
        isForWaste
        isEmissionToAir
        isElementaryFlow
        isPackaging
        description
        updated
        lastUpdatedName
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
